import type { FC } from "react";
import { useGoalsRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import { TimelineItemLegacyLayout } from "web_myplann/NotificationCenter/Components/TimelineItemLegacyLayout";
import { TimelineItemV2Layout } from "web_myplann/NotificationCenter/Components/TimelineItemV2Layout";
import type { TimelineItemLayoutProps } from "web_myplann/NotificationCenter/Types/TimelineItemLayoutProps";

export const TimelineItemLayout: FC<TimelineItemLayoutProps> = (props) => {
	const hasGoalsRight = useGoalsRightOptional();

	return hasGoalsRight ? (
		<TimelineItemV2Layout {...props} />
	) : (
		<TimelineItemLegacyLayout {...props} />
	);
};
